module.exports = __webpack_public_path__ + "static/media/hands-heart.406dd8ad.svg";